import React from "react";

import footerlogo from "../../assets/Skyline Logo 3.svg";
import "./FooterSection.css";

const FooterSection = () => {
  return (
    <footer className="container-fluid" style={{ backgroundColor: "#036" }}>
      <div className="container">
        <div className="row align-items-center ">
          <div className="col-lg-3 col-md-12 d-flex justify-content-lg-start justify-content-center mb-3 mb-lg-0">
            <a href="#home">
              <img src={footerlogo} alt="Logo" className="footer-logo" />
            </a>
          </div>

          <div className="col-lg-6 col-md-12 d-flex justify-content-center text-center custom-col-gap">
            <ul className="list-unstyled d-flex flex-wrap justify-content-center mb-0 flex-column flex-md-row">
              <li className="mx-2 text-decoraton-none">
                <a href="#home" className="footerName text-decoration-none">
                  Home
                </a>
              </li>
              <li className="mx-2">
                <a href="#about-us" className="footerName text-decoration-none">
                  About Us
                </a>
              </li>
              <li className="mx-2">
                <a
                  href="#our-projects"
                  className="footerName text-decoration-none"
                >
                  Our Projects
                </a>
              </li>
              <li className="mx-2">
                <a
                  href="#location-map"
                  className="footerName text-decoration-none"
                >
                  Location
                </a>
              </li>
              <li className="mx-2">
                <a
                  href="#contact-us"
                  className="footerName text-decoration-none"
                >
                  Contact us
                </a>
              </li>
            </ul>
          </div>

          {/* <div className="col-lg-3 col-md-12 d-flex justify-content-lg-end justify-content-center custom-col-gap">
            <div className="d-flex">
              <a href="#facebook" className="mx-2 ">
                <img src={linkedin} alt="linkedin" />
              </a>
              <a href="#twitter" className="mx-2 ">
                <img src={twitter} alt="twitter" />{" "}
              </a>
              <a href="#instagram" className="mx-2 ">
                <img src={instgram} alt="instagram" />{" "}
              </a>
              <a href="#linkedin" className="mx-2 ">
                <img src={faceBook} alt="facebook" />{" "}
              </a>
            </div>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
